import React, {useEffect} from 'react';
import {createTheme, makeStyles, MuiThemeProvider} from '@material-ui/core/styles';
import {Box, Paper, TextField, Typography} from '@material-ui/core'
import SyncOffice from './syncOffice.png'
import {ApiPostData} from "@project/shared/src/services/ApiPostData";
import {commonValidation} from "@project/shared/src/services/commonValidation";
import {toast} from "react-toastify";
import 'react-phone-input-2/lib/style.css';
import {BaseLink, BaseServerParentSite, BaseServerWebsite, BaseURL} from "@project/shared/src/services/postData";
import MaterialUiButtons from "@project/shared/src/components/button/materialUiButton";
import DialogBoxV2 from "@project/shared/src/components-v2/dialogBox/dialogBoxV2";
import {employeeMain, employeePrimary, employeePrimaryShadow, employeeSecondary, greenColor, redColor} from "@project/shared/src/colorCode/colorCode";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import UsersAnim from "@project/shared/src/Animation/usersAnim";
import {nodePostLink,encodeString} from "@project/shared/src/services/nodePost";



const theme = createTheme({
  overrides: {
    MuiOutlinedInput: {
      root: {
        "&$focused $notchedOutline": {
          border: "1px solid #66afe9 !important",
          outline: 'none',
          boxShadow: "inset 0 1px 1px rgba(0, 0, 0, .075), 0 0 8px rgba(102, 175, 233, .6) !important"
        },
      },
    },
  },
  typography: {
    fontFamily: [
      '"Montserrat", sans-serif'+'!important'
    ].join(','),
  },
});


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,

    textAlign: 'left',
  },
  saveBtn:{
    background:'#045e06',
    color:'white'
  },
  paper: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },

  linkStyle:{
    textDecoration:'none',
    "&:hover":{
      textDecoration:'underline',
      color: 'gray',
    }
  },

  customTextField :props=>({
    "& >label":{
      // background:'white',
    },
    "& .MuiSelect-icon":{
      position:"inherit",
      cursor:"pointer"
    },
    "&>div>fieldset>legend":{
      background:'white'
    },
    "& .MuiIconButton-root:focus":{
      outline:"none"
    },
    "& >div>svg":{
      right:props.iconData!==undefined?
        props.iconData.length===2?62:props.iconData.length===1?41:props.iconData.length===3?84:""
        :"",
    },
  }),

  errorStyle:{
    color: 'red',
    float: 'left',
    padding: '0 5px',
    transform: 'translate(-5px, 6px) scale(0.75)',
    background: 'white',
    height: 'max-content',
    marginTop: '-19px',
  },
}));
const fields = {
  email: {value: '', valid: false, errorLabel: 'Enter Valid Email', error: ''},
  'password': {value: '', valid: false, errorLabel: 'Enter Valid Password', error: ''}
};


const Login = () => {
  const classes = useStyles();
  const [modalStatusLicence, setmodalStatusLicence] = React.useState({status:false});

  const [Field, setField] = React.useState({...fields});
  const [formValid, setFormValid] = React.useState(false);
  const [licenceList, setLicenceList] = React.useState([]);
  const [licenceVal, setlicenceVal] = React.useState('');
  const propsDrawer = {
    background: employeePrimary,
    boxShadow: employeePrimaryShadow,
    secondaryBg:   employeeSecondary,
    mainBg: employeeMain,
    cardIcon:<UsersAnim fill='white' stroke={employeeMain} height='45'/>
  };

  useEffect(()=>{
    if(localStorage.getItem('userData')) {
      nodePostLink('/auth/authenticate/checkUserLoggedInOrNot', []).then(result => {
        window.location=`${process.env.REACT_APP_DASHBOARD}/dashboard`;
      });
    }
  },[]);

  const handleClickOpen = (id) => {

      var email = Field['email'].value.trim();
      var password = Field['password'].value;
      let data = {};


    data['username']= email ;
    data['password']= password;

   nodePostLink('/auth/authenticate/login', data).then(result => {

      switch(result.indicator){
        case 7:
          localStorage.setItem("userData",encodeString(JSON.stringify(result.data)));
         window.location=`${process.env.REACT_APP_DASHBOARD}/dashboard`;
          break;
        case 1:
          toast.error('Invalid Email or Password');
          break;
        case 2:
          toast.error('You are not Authorised to login');
        break;
        case 3:
          toast.error('You are not Authorised to login');
        break;
        case 4:
          toast.error('Login date is expired, please contact your superadmin');
        break;
        case 5:
          toast.error('Login date is expired, please contact your superadmin');
         break;
        case 6:
          toast.error('You are already logged in from another system please logout and login');
          break;
        case 8:
          getemailormobileno(email);
        break;
        case 9:
          toast.error( 'Licence Not Activated');
        break;
        case 10:
          showLicenceListForLogin(result);
          break;
      }

    });

  };

  function showLicenceListForLogin(records){
    let modalDrawer={...propsDrawer};
    modalDrawer.subTitle='Select';
    modalDrawer.title='licence'
    modalDrawer.status=true;
    modalDrawer.width='xs';
    setLicenceList([...records.data]);
    setmodalStatusLicence(modalDrawer);
  }


  function showLicenceListForEmail(records){
    //modal set to true to display-modalStatusEmail
    setLicenceList([...records.data]);
  }


  function loginWithParticularLicence(){
    let arryDetails ={};
    if(licenceVal) {
      licenceList.map(data => {
        if (licenceVal == data['licence_name']) {
          arryDetails['loginData'] = data;
          nodePostLink('/auth/authenticate/multipleLicenseLogin', arryDetails).then(result => {
            switch (result.indicator) {
              case 7:
                localStorage.setItem("userData",encodeString(JSON.stringify(result.data)));
                window.location=`${process.env.REACT_APP_DASHBOARD}/dashboard`;
                break;
              case 1:
                toast.error('Invalid Email or Password');
                break;
              case 2:
                toast.error('You are not Authorised to login');
                break;
              case 3:
                toast.error('You are not Authorised to login');
                break;
              case 4:
                toast.error('Login date is expired, please contact your superadmin');
                break;
              case 5:
                toast.error('Login date is expired, please contact your superadmin');
                break;
              case 6:
                toast.error('You are already logged in from another system please logout and login');
                break;
              case 8:
                // getemailormobileno(email);
                break;
              case 9:
                toast.error('Licence Not Activated');
                break;
            }
          });
        }
      });
    }else{
      toast.error('Select the licence');
    }
  }









  function getemailormobileno(email) {
    let data= {};
    data['email']=email;
    ApiPostData('api/websiteApi.php', 'getdataforpws', data).then(result => {
      switch(result.status){
        case 2:
          toast.error('Email Id does not exist');
          break;
        case 3:
          toast.error('Account not yet activated');
          break;
        case 4:
          showLicenceListForEmail(result);
          //display licencelist
          break;
        case 5:
          //display otp box
          break;
      }


    });

  }




  const blurInField = (e, fieldname, validationType) => {
    let updateForm = {...Field};
    let formValidVar = true;
    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;


    updateFormField.valid = commonValidation(e.target.value, validationType);

    if (!updateForm[fieldname].valid) {
      updateFormField.error = updateFormField.errorLabel;
    } else {
      updateFormField.error = '';
    }
    updateForm[fieldname] = updateFormField

    for (let key in Field) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setField(updateForm);
    setFormValid(formValidVar);
  }

  const changeInField = (e, fieldname) => {
    let updateForm = {...Field};

    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;

    updateForm[fieldname] = updateFormField
    setField(updateForm);
  }

  const changeInPassword = (e, fieldname,validationType) => {
    let updateForm = {...Field};

    let updateFormField = updateForm[fieldname];
    updateFormField.value = e.target.value;
    updateFormField.valid = commonValidation(e.target.value, validationType);
    let formValidVar = true;
    updateForm[fieldname] = updateFormField
    setField(updateForm);
    for (let key in Field) {
      formValidVar = updateForm[key].valid && formValidVar;
    }
    setFormValid(formValidVar)
  }

  const licenceListStructure=(data,index)=>{
    return (
      <Box className="border-bottom" key={index}>
         <FormControlLabel className="mb-0" value={data.licence_name}  control={<Radio />} label={data.licence_name}  />
      </Box>
    );
  }

  const changeCheckBoxLicence=(event)=>{
    setlicenceVal(event.target.value);
  }

  return (
    <MuiThemeProvider theme={theme}>
      <Box className={classes.root} pt={2} px={3} >
        <img src={SyncOffice} alt='SyncOffice' style={{height: 100}}/>

        <Paper className={classes.paper}>
          <Typography variant="h5" color='textPrimary'>
            Login
          </Typography>

          <form className={classes.form} noValidate autoComplete="off">
            <Box mt={3}>
              <TextField
                label='Username'
                variant='outlined'
                size='small'
                fullWidth
                className={classes.customTextField}
                value={Field['email']['value']}
                onChange={(event) => changeInField(event, 'email',)}
                onBlur={(event) => blurInField(event, 'email', {required: true, validationType: 'email'})}
              />
              {!Field['email'].valid ?
                <div className={classes.errorStyle}>
                    <Typography variant="caption" style={{color: 'red'}}>
                      {Field['email'].error}
                    </Typography>
                </div>
                :
                <span></span>
              }
            </Box>

            <Box mt={4}>
            <TextField
              label='Password'
              variant='outlined'
              type="password"
              size='small'
              required
              fullWidth
              className={classes.customTextField}
              value={Field['password'].value}
              onChange={(event) => changeInPassword(event, 'password',{required: true, validationType: ''})}
              onBlur={(event) => blurInField(event, 'password', {required: true, validationType: ''})}
            />
            {!Field['password'].valid ?
              <div className={classes.errorStyle}>
                  <Typography variant="caption" style={{color: 'red'}}>
                    {Field['password'].error}
                  </Typography>
              </div>
              :
              ""
            }
            </Box>
          </form>

          <Box display="flex" mt={4}>
            <Box mr={2} flexGrow={1}>
              <a href={`${BaseLink}${BaseServerWebsite}freetrial`} style={{textDecoration:'none'}}>
                <MaterialUiButtons
                  color="#536DFE"
                  btnTitle="Free Trial"
                  iconName="loyalty"
                  btnSize="small"
                />
              </a>
            </Box>
            <Box display="flex" >
              <Box mr={2}>
                <a href={`${BaseLink}${BaseServerParentSite}`} style={{textDecoration:'none'}}>
                  <MaterialUiButtons
                    color={redColor}
                    btnTitle="Cancel"
                    iconName="close"
                    btnSize="small"
                  />
                </a>
              </Box>
              <Box>
                <MaterialUiButtons
                  btnClick={()=>handleClickOpen(0)}
                  color="#1b5e20"
                  btnTitle="Login"
                  btnDisable={!formValid}
                  iconName='login'
                  btnSize="small"
                />
              </Box>
            </Box>
          </Box>

          {/* <Box textAlign="right" mt={4}>
            <a className={classes.linkStyle} href={`${BaseLink}${BaseServerWebsite}forgotPassword`}>
              <Typography variant="body2" color="textSecondary">
                Forgot Password
              </Typography>
            </a>
          </Box> */}

        </Paper>
        <DialogBoxV2
          openDialog={modalStatusLicence.status}
          closeDialog={()=>setmodalStatusLicence({status:false})}
          propsDrawer={modalStatusLicence}
          footer={true}
          footerRightBtnData={[
            {name:'Cancel',action: ()=>setmodalStatusLicence({status:false}),disable:false,color:redColor,iconName:'close'},
            {name:'Submit',
              action:()=>loginWithParticularLicence(),
              color:greenColor,
              iconName:'save'},
          ]}
        >
          <Box display="flex" alignItems="center" height={1} p={2}>
            <Box width={1} >
              <Typography variant="subtitle2" >
                <RadioGroup aria-label="Licence List" name="licence" value={licenceVal} onChange={changeCheckBoxLicence}>
                {
                  licenceList.map(licenceListStructure)
                }
                </RadioGroup>
              </Typography>
            </Box>
          </Box>
        </DialogBoxV2>

      </Box>

    </MuiThemeProvider>
  );
};

export default Login;
